import { useEffect } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Direct pass-through open redirect: /r?url=https://anywhere.com
export default function PassThrough() {
  useEffect(() => {
    document.title = "Redirecting recipient";
    const url = new URLSearchParams(window.location.search).get("url");
    if (url) {
      window.location.replace(`${BACKEND}/api/open?url=${encodeURIComponent(url)}`);
    } else {
      window.location.replace("/");
    }
  }, []);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center mono text-sm text-zinc-500">
      One moment<span className="cursor-blink">…</span>
    </div>
  );
}
